import { render } from "./Index_team_en.vue?vue&type=template&id=3107a8e2&scoped=true"
import script from "./Index_team_en.vue?vue&type=script&lang=js"
export * from "./Index_team_en.vue?vue&type=script&lang=js"

import "./Index_team_en.vue?vue&type=style&index=0&id=3107a8e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3107a8e2"

export default script